import { render, staticRenderFns } from "./ffswiperimg.vue?vue&type=template&id=5cacadd8&"
import script from "./ffswiperimg.vue?vue&type=script&lang=js&"
export * from "./ffswiperimg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports